import React, { Component } from 'react'

import { OptionView, OptionButtonSecondary, OptionButtonSuccess, OptionButtonDanger } from '../StyledComponents/IntroQuestions/Option'

class Option extends Component {
    constructor(props) {
        super(props)

        this.optionClicked = this.optionClicked.bind(this)
    }

    optionClicked() {
        const { onOptionClicked, data } = this.props

        onOptionClicked(data)
    }

    render() {
        const { data, fullWidth } = this.props
        const { label } = data

        const block = fullWidth ? true : null

        let button = null
        switch (label.toLowerCase()) {
            case 'yes':
                button = <OptionButtonSuccess outline color="success" block={block}>Ja</OptionButtonSuccess>
                break
            case 'no':
                button = <OptionButtonDanger outline color="danger" block={block}>Nein</OptionButtonDanger>
                break
            default:
                button = <OptionButtonSecondary outline color="secondary" block={block}>{label}</OptionButtonSecondary>
        }

        return (
            <OptionView fullWidth={fullWidth} onClick={this.optionClicked}>
                {button}
            </OptionView>
        )
    }
}

export default Option



// WEBPACK FOOTER //
// ./src/components/IntroQuestions/Option.js